import { render, staticRenderFns } from "./shopSubjectSignUp.vue?vue&type=template&id=b33add3a&"
import script from "./shopSubjectSignUp.vue?vue&type=script&lang=js&"
export * from "./shopSubjectSignUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports